import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchUserProfileUserGroups } from 'common/services/api/UserProfileUserGroups/UserProfileUserGroups.thunk';
import { UserGroup } from 'common/types/Entities';
import { createMemoizedKeySelector } from 'common/utils/selectorUtils';

interface UserProfileUserGroupsSliceState {
    userUserGroupsByTenantId: Record<string, UserGroup[]>;
    processing: string | false;
}

type StateWithUserProfileUserGroups = { userProfileUserGroups: UserProfileUserGroupsSliceState };

const initialState: UserProfileUserGroupsSliceState = {
    userUserGroupsByTenantId: {},
    processing: false,
};

const userProfileUserGroupsSlice = createSlice({
    name: 'userProfileUserGroups',
    initialState,

    reducers: (create) => ({
        clearUserProfileUserGroups: create.reducer(state => {
            state.userUserGroupsByTenantId = {};
        })
    }),

    extraReducers: builder => {
        builder.addCase(fetchUserProfileUserGroups.pending, (state, args) => {
            state.processing = args.meta.arg.tenantId;
            state.userUserGroupsByTenantId[args.meta.arg.tenantId] = [];
        });
        builder.addCase(fetchUserProfileUserGroups.fulfilled, (state, action: PayloadAction<UserGroup[]>) => {
            state.processing = false;
            if(action.payload.length) {
                const tenantId = action.payload[0].tenantId;
                state.userUserGroupsByTenantId = {
                    ...state.userUserGroupsByTenantId,
                    [tenantId]: action.payload
                };
            }
        });
        builder.addCase(fetchUserProfileUserGroups.rejected, (state, args) => {
            state.processing = false;
            state.userUserGroupsByTenantId[args.meta.arg.tenantId] = [];
        });
    }
});

// eslint-disable-next-line no-restricted-syntax
export default userProfileUserGroupsSlice.reducer;
export const { clearUserProfileUserGroups } = userProfileUserGroupsSlice.actions;

// Base selector for byTenantId state
const selectUserUserGroupsByTenantIdState = (state: StateWithUserProfileUserGroups) => state.userProfileUserGroups.userUserGroupsByTenantId;

// Memoized parameterized selector
export const selectUserProfileUserGroupsByTenantId = createMemoizedKeySelector(selectUserUserGroupsByTenantIdState);
export const selectProcessing = (state: StateWithUserProfileUserGroups) => state.userProfileUserGroups.processing;
